import { render } from "./BaseDataTable.vue?vue&type=template&id=3669cc29&scoped=true"
import script from "./BaseDataTable.vue?vue&type=script&lang=js"
export * from "./BaseDataTable.vue?vue&type=script&lang=js"

import "./BaseDataTable.vue?vue&type=style&index=0&id=3669cc29&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3669cc29"]])

export default __exports__